import React from "react";
import { IconType } from "react-icons";
import { LuChevronDown, LuChevronRight } from "react-icons/lu";

interface SidebarItemProps {
  label: string;
  isActive?: boolean;
  icon?: IconType;
  onClick?: () => void;
  indentLevel?: number;
  hasSubItems?: boolean;
  isExpanded?: boolean;
}

export const SidebarItem = ({
  label,
  icon: Icon,
  isActive,
  onClick,
  indentLevel = 0,
  hasSubItems = false,
  isExpanded = false,
}: SidebarItemProps) => {
  const RenderedIcon = Icon as React.ElementType;
  const LuChevronDownIcon = LuChevronDown as React.ElementType;
  const LuChevronRightIcon = LuChevronRight as React.ElementType;

  return (
    <div
      onClick={onClick}
      className={`rounded-lg py-4 text-sm text-gray-500 cursor-pointer hover:bg-indigo-900/10 transition flex items-center justify-between ${
        isActive && "bg-indigo-700/10 text-indigo-900"
      }`}
      style={{ paddingLeft: `${indentLevel * 20 + 20}px` }}
    >
      <div className="flex items-center space-x-2">
        {Icon && <RenderedIcon className="text-xl" />}
        <span>{label}</span>
      </div>
      {hasSubItems && (
        <span className="pr-4">
          {isExpanded ? (
            <LuChevronDownIcon className="text-gray-500" />
          ) : (
            <LuChevronRightIcon className="text-gray-500" />
          )}
        </span>
      )}
    </div>
  );
};
